/** @jsx jsx */
/**
 * Package Here: https://github.com/s-yadav/react-number-format
 */
import { jsx, css } from "@emotion/core";
import NumberFormat from "react-number-format";

import BaseInput from "../Input";

const Input = ({
  current,
  errorMessage,
  ...props
}: {
  current: any;
  errorMessage?: string;
  [key: string]: any;
}) => (
  <BaseInput
    {...props}
    helperText={errorMessage}
    css={css`
      margin-bottom: 20px;
    `}
  />
);

const CurrencyInput = ({
  thousandSeparator = ",",
  decimalSeparator = ".",
  allowLeadingZeros = true,
  fixedDecimalScale = true,
  decimalScale = 2,
  prefix = "$",
  ...props
}) => {
  return (
    <NumberFormat
      customInput={Input}
      thousandSeparator={thousandSeparator}
      allowLeadingZeros={allowLeadingZeros}
      fixedDecimalScale={fixedDecimalScale}
      decimalScale={decimalScale}
      prefix={prefix}
      {...props}
    />
  );
};

export default CurrencyInput;
